import { useState, useEffect } from 'react';

const Puertos =
({
    checking,
    setChecking,
    codigosPuertos,
    setCodigosPuertos,
    checkboxesPuertos,
    setCheckboxesPuertos,
    puertos,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const [count, setCount] = useState(0);

    const appDebug = process.env.REACT_APP_DEBUG;

    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const puerto = e.target.value;

        if (checked === true)
        {
            const puertos = [];

            for (let i = 0; i < codigosPuertos.length; i++)
            {
                puertos.push(codigosPuertos[i]);
            }

            puertos.push(puerto);

            setCodigosPuertos(puertos);
        }
        else
        {
            const puertos = codigosPuertos.filter(nombre => nombre !== puerto);

            setCodigosPuertos(puertos);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesPuertos(
        {
            ...checkboxesPuertos,
            [puerto]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_experto_pesqueria_checkbox_puerto',
                buscador_experto_pesqueria_checkbox_puerto: document.querySelector(`label[for="${e.target.id}"]`).textContent,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setPagination(1);
    }

    useEffect(() =>
    {
        let contador = 0;

        puertos.map((puerto) => (contador += puerto.REGISTROS));

        setCount(contador);
    }, [puertos]);

    const groupedPuertos = puertos.reduce((acc, puerto) =>
    {
        const firstLetter = puerto.NOMBRE_PUERTO[0].toUpperCase();

        if (!acc[firstLetter])
        {
            acc[firstLetter] = [];
        }

        acc[firstLetter].push(puerto);

        return acc;
    }, {});

    return (
        count > 0 &&
        (
            <div className="card border-0 mb-1">
                <div className="accordion" id="accordionPanelEspecie">
                    <div className="accordion-item">
                        <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsPuertos" aria-expanded="true" aria-controls="panelsPuertos">Puertos:</button></h5>
                        <div id="panelsPuertos" className="accordion-collapse collapse">
                            <div className="accordion" id="accordionPuertos">

                                {
                                    Object.keys(groupedPuertos).sort().map((letter, index) =>
                                    (
                                        <div className="accordion-item" key={index}>
                                            <h2 className="accordion-header" id={`heading-${index}`}>
                                                <button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${index}`} aria-expanded="false" aria-controls={`collapse-${index}`}>
                                                    {letter}
                                                </button>
                                            </h2>
                                            <div id={`collapse-${index}`} className="accordion-collapse collapse" aria-labelledby={`heading-${index}`}>
                                                <div className="accordion-body">

                                                    {
                                                        groupedPuertos[letter].map((puerto, subIndex) =>
                                                        (
                                                            <div className="row" key={subIndex}>
                                                                <div className="col">
                                                                    <div className="form-check">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input border-dark-subtle"
                                                                            id={`puerto-${index}-${subIndex}`}
                                                                            name="nombre_especie"
                                                                            value={puerto.PUERTO_RECALADA}
                                                                            onChange={handleChildCheckbox}
                                                                            checked={Object.hasOwn(checkboxesPuertos, `${puerto.PUERTO_RECALADA}`) ? checkboxesPuertos[`${puerto.PUERTO_RECALADA}`] : false}
                                                                            disabled={!status422 && (!loading || checking || sorting)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`puerto-${index}-${subIndex}`}>{puerto.NOMBRE_PUERTO}</label>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    appDebug === 'true' &&
                                                                    (
                                                                        <div className="col-3 text-end">{puerto.REGISTROS.toLocaleString('es-CL')}</div>
                                                                    )
                                                                }

                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        {
                            appDebug === 'true' &&
                            (
                                <div className="text-end p-2">Elementos totales: {count.toLocaleString('es-CL')}</div>
                            )
                        }

                    </div>
                </div>
            </div>
        )
    );
}

export default Puertos;
